// Remote config at boot (§4.3): fetched with a short timeout, cached for offline starts, and
// applied to TUNABLES + feature flags BEFORE the engine is created.
import { applyRemoteConfig, type RemoteConfig } from "@degen/shared/remoteConfig";
import { signal } from "@preact/signals";
import { api } from "./api";
import { online } from "./env";

const KEY = "degen-world:config";
export const season = signal<RemoteConfig["season"]>(null);

export async function loadRemoteConfig(): Promise<number> {
  let cfg: RemoteConfig | null = null;
  if (online()) {
    try {
      cfg = await api<RemoteConfig>("GET", "/config", undefined, { auth: false, timeoutMs: 1500 });
      localStorage.setItem(KEY, JSON.stringify(cfg));
    } catch {
      /* fall back to cache */
    }
  }
  if (!cfg) {
    try {
      cfg = JSON.parse(localStorage.getItem(KEY) ?? "null");
    } catch {
      cfg = null;
    }
  }
  if (!cfg) return 0;
  applyRemoteConfig(cfg);
  season.value = cfg.season ?? null;
  return cfg.version;
}
